import CancelUpdatesModal from './CancelUpdatesModal';

export default CancelUpdatesModal;
